import { post, read } from '@/utils/request';
import type { OfflinePaymentAPI } from './interface';

// 灰度信息
const getVaGrayscale = () => {
  return read<OfflinePaymentAPI.Response.Grayscale>(
    'user/grayscale',
    undefined,
    undefined,
    undefined,
    { isCamel: false, isLower: false },
  );
};

// 开通HsVa账号
const assignVa = (params: OfflinePaymentAPI.Request.VaAssign) =>
  post('va/assign', params, undefined, undefined, { isCamel: false, isLower: false });

// 获取HsVa账号信息
const getVaInfo = () =>
  read<OfflinePaymentAPI.Response.VaInfo>('va/va_info', undefined, undefined, undefined, {
    isCamel: false,
    isLower: false,
  });

export { getVaGrayscale, assignVa, getVaInfo };
